import { render, staticRenderFns } from "./CommonTable.vue?vue&type=template&id=6b1fc056&scoped=true"
import script from "./CommonTable.vue?vue&type=script&lang=js"
export * from "./CommonTable.vue?vue&type=script&lang=js"
import style0 from "./CommonTable.vue?vue&type=style&index=0&id=6b1fc056&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1fc056",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/测试环境-前端-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b1fc056')) {
      api.createRecord('6b1fc056', component.options)
    } else {
      api.reload('6b1fc056', component.options)
    }
    module.hot.accept("./CommonTable.vue?vue&type=template&id=6b1fc056&scoped=true", function () {
      api.rerender('6b1fc056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/CommonTable.vue"
export default component.exports